import type { ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import CrashGame from '@/components/games/crash-game'
import { GameHeader } from '@/components/games/game-ui'
import { GAMES } from '@/constants/site'

const game = GAMES[2]

const CrashPage = (): ReactNode => {
    return (
        <>
            <Seo title='Crash' description='Ride the rocket and cash out your DonutSMP money before it blows. Set an auto cash-out or time it yourself.' />
            <GameHeader title={game.name} subtitle={game.subtitle} />
            <CrashGame />
        </>
    )
}

export default CrashPage
